module.exports = {
          srcSet: __webpack_public_path__ + "5a292bb6335b9ba4a211882725e9f245-2629.png"+" 2629w",
          images:[ {path: __webpack_public_path__ + "5a292bb6335b9ba4a211882725e9f245-2629.png",width: 2629,height: 2709}],
          src: __webpack_public_path__ + "5a292bb6335b9ba4a211882725e9f245-2629.png",
          toString:function(){return __webpack_public_path__ + "5a292bb6335b9ba4a211882725e9f245-2629.png"},
          
          width: 2629,
          height: 2709
        }